import { IAuthenticationService, IAuthenticationToken, IAuthenticationUser } from '@metaos/hub-sdk';
import { UserInfo } from '@metaos/hub-sdk/dist/Services/hosted-web-content-sdk.interface';
import { getAccessTokenforResource } from 'owa-tokenprovider';

export default class AuthenticationService implements IAuthenticationService {
    private user: UserInfo;

    constructor(user: UserInfo) {
        this.user = user;
    }

    public acquireToken = async (resource: string): Promise<IAuthenticationToken> => {
        const token = await getAccessTokenforResource(
            resource,
            undefined /* apiName */,
            undefined /* requestId */,
            undefined /* targetTenantId */,
            undefined /* wwwAuthenticateHeader */,
            true /* preferIdpToken */
        );
        return Promise.resolve({
            token,
        } as IAuthenticationToken);
    };

    public getUser = async (): Promise<IAuthenticationUser> => {
        return Promise.resolve({
            profile: {
                oid: this.user.id,
                tid: this.user.tenant?.id,
                upn: this.user.userPrincipalName,
            },
        } as IAuthenticationUser);
    };
}
